var map = {
	"./alarm-active.svg": 11,
	"./alarm.svg": 104,
	"./business-system.svg": 9755,
	"./calendar-active.svg": 2186,
	"./calendar.svg": 1347,
	"./empty-page.svg": 3236,
	"./finance-system.svg": 4509,
	"./jishiotngxun-active.svg": 3224,
	"./jishiotngxun.svg": 1173,
	"./management-system.svg": 6002,
	"./message-active.svg": 277,
	"./message.svg": 5278,
	"./ruoyi-ui.svg": 5402,
	"./workbench-active.svg": 2943,
	"./workbench.svg": 3284
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 279;